import { Component, computed, inject, input } from '@angular/core';

import type { AggregatedEvaluationsQuestionOption } from '@core/evaluations-types';
import { I18nService } from '@core/i18n-legacy';
import { Theme } from '@core/theme-util';

import { CandidateOfferEvaluationQuestionOptionsDistributionComponent } from '../candidate-offer-evaluation-question-options-distribution/candidate-offer-evaluation-question-options-distribution.component';

@Component({
  selector: 'rt-candidate-offer-evaluation-question-boolean-distribution',
  template: `
    <rt-candidate-offer-evaluation-question-options-distribution
      [questionTitle]="questionTitle()"
      [answersCount]="answersCount()"
      [commentsCount]="commentsCount()"
      [options]="options()"
      [theme]="theme()"
    />
  `,
  imports: [CandidateOfferEvaluationQuestionOptionsDistributionComponent],
})
export class CandidateOfferEvaluationQuestionBooleanDistributionComponent {
  private readonly i18n = inject(I18nService);

  public questionTitle = input.required<string | null>();
  public answersCount = input.required<number>();
  public commentsCount = input(0);
  public yes = input.required<number>();
  public no = input.required<number>();
  public theme = input.required<Theme>();

  protected options = computed<AggregatedEvaluationsQuestionOption[]>(() => [
    { title: this.i18n.translate('app.common.boolean.yes'), count: this.yes() },
    { title: this.i18n.translate('app.common.boolean.no'), count: this.no() },
  ]);
}
